import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faCode, faUser, faAward, faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import React, { useContext, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import aroundweb from "../../assets/images/aroundweb.jpg";
import ccna from "../../assets/images/ccna.jpg";
import gadaweb from "../../assets/images/gadaweb.jpg";
import lacerba from "../../assets/images/lacerba.png";
import logo from "../../assets/images/logo.png";
import dva from "../../assets/images/dva.webp";
import itgo from "../../assets/images/itgo.png";
import lpi from "../../assets/images/lpi.jpg";
import { Context } from "../../context";
import Spacer from "../Utils/Spacer";
import classes from "./About.module.css";

const AboutMe = () => {
  const { debug, lang, linkedin, github } = useContext(Context);
  const [minHeightApplied, setMinHeightApplied] = useState(false);

  return (
    <>
      <Container fluid className={classes.curriculumContainerBg}>
        <Container fluid className={classes.curriculumContainer}>
          <Spacer height="50" mobile={false} />
          <Row>
            <Col xs={12} sm={12} md={3}>
              <motion.div
                className={classes.boxPhoto}
                style={{ minHeight: "450px" }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3, ease: "easeOut", delay: 0.05 }}
              >
                <div className={classes.titleBarLight}>
                  <div className={classes.dots}>
                    <div className={`${classes.dot} ${classes.dotRed}`}></div>
                    <div className={`${classes.dot} ${classes.dotYellow}`}></div>
                    <div className={`${classes.dot} ${classes.dotGreen}`}></div>
                  </div>
                  <div className={classes.tabLight}>
                    <FontAwesomeIcon icon={faUser} className={classes.tabIcon} /> Profile.json
                  </div>
                </div>
                <motion.div
                  className={classes.boxPhotoTop}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.25, ease: "easeOut", delay: 0.1 }}
                >
                  <motion.img
                    src="assets/images/db.jpg"
                    className={classes.boxPhotoImg + " mt-5"}
                    alt="db"
                    initial={{ opacity: 0, y: -6 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      duration: 0.25,
                      ease: "easeOut",
                      delay: 0.15,
                    }}
                  />
                  <motion.h2
                    className={classes.boxPhotoTitle + " mt-3"}
                    initial={{ opacity: 0, y: -6 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      duration: 0.25,
                      ease: "easeOut",
                      delay: 0.2,
                    }}
                  >
                    Davide Balice
                  </motion.h2>
                  <motion.h3
                    className={classes.boxPhotoDescription + " mt-1 mb-4"}
                    initial={{ opacity: 0, y: -6 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      duration: 0.25,
                      ease: "easeOut",
                      delay: 0.25,
                    }}
                  >
                    Full stack web developer
                  </motion.h3>
                  <div className={classes.socialContainer + " mb-5"}>
                    <motion.a
                      className={classes.social}
                      href={linkedin}
                      target="_blank"
                      rel="noreferrer"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{
                        duration: 0.25,
                        ease: "easeOut",
                        delay: 0.3,
                      }}
                    >
                      <FontAwesomeIcon icon={faLinkedin} size="2x" />
                    </motion.a>
                    <motion.a
                      className={classes.social}
                      href={github}
                      target="_blank"
                      rel="noreferrer"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{
                        duration: 0.25,
                        ease: "easeOut",
                        delay: 0.35,
                      }}
                    >
                      <FontAwesomeIcon icon={faGithub} size="2x" />
                    </motion.a>
                  </div>
                </motion.div>
              </motion.div>
            </Col>

            <Col xs={12} sm={12} md={9} className={classes.mobileMargin}>
              <motion.div
                className={classes.boxText}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3, ease: "easeOut", delay: 0.05 }}
              >
                <div className={classes.titleBarLight}>
                  <div className={classes.dots}>
                    <div className={`${classes.dot} ${classes.dotRed}`}></div>
                    <div className={`${classes.dot} ${classes.dotYellow}`}></div>
                    <div className={`${classes.dot} ${classes.dotGreen}`}></div>
                  </div>
                  <div className={classes.tabLight}>
                    <FontAwesomeIcon icon={faUser} className={classes.tabIcon} /> Info.json
                  </div>
                </div>
                <div className={classes.boxBody}>
                  <Row className={classes.aboutHeader}>
                    <Col xs={12} sm={12} md={6}>
                      <motion.div
                        className={classes.boxBodyTitleSection}
                        initial={{ opacity: 0, y: -6 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                          duration: 0.25,
                          ease: "easeOut",
                          delay: 0.1,
                        }}
                      >
                        {lang === "en" && <>Personal information</>}
                        {lang === "it" && <>Informazioni personali</>}
                      </motion.div>

                      <motion.table
                        className="table mt-5"
                        initial={{ opacity: 0, y: -6 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                          duration: 0.25,
                          ease: "easeOut",
                          delay: 0.15,
                        }}
                      >
                        <tbody>
                          <tr>
                            <td className={classes.tableCol1}>
                              {lang === "en" && <>Full name</>}
                              {lang === "it" && <>Nome</>}
                            </td>
                            <td className={classes.tableCol2}>
                              Davide Michele Balice
                            </td>
                          </tr>
                          <tr>
                            <td className={classes.tableCol1}>Email</td>
                            <td className={classes.tableCol2}>
                              davide.balice@gmail.com
                            </td>
                          </tr>
                          <tr>
                            <td className={classes.tableCol1}>
                              {lang === "en" && <>From</>}
                              {lang === "it" && <>Da</>}
                            </td>
                            <td className={classes.tableCol2}>
                              {lang === "en" && <>Italy, Reggio Calabria</>}
                              {lang === "it" && <>Reggio Calabria</>}
                            </td>
                          </tr>
                        </tbody>
                      </motion.table>

                      <motion.p
                        className={`${classes.boxBodyText2} pt-4`}
                        initial={{ opacity: 0, y: -6 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                          duration: 0.25,
                          ease: "easeOut",
                          delay: 0.2,
                        }}
                      >
                        {lang === "en" && (
                          <>
                            I am available for
                            <br />
                            new projects and collaborations.
                          </>
                        )}
                        {lang === "it" && (
                          <>
                            Sono disponibile per
                            <br />
                            nuovi progetti e collaborazioni.
                          </>
                        )}
                      </motion.p>
                    </Col>

                    <Col xs={12} sm={12} md={6}>
                      <motion.iframe
                        src="https://mug.davidebalice.dev/"
                        title="mug"
                        className={classes.mugFrame}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{
                          duration: 0.25,
                          ease: "easeOut",
                          delay: 0.2,
                        }}
                      />
                    </Col>
                  </Row>
                </div>
              </motion.div>
            </Col>
          </Row>

          <Spacer height="24" mobile={false} />

          <Row>
            <Col xs={12} sm={12} md={12}>
              <motion.div
                className={classes.boxText}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3, ease: "easeOut", delay: 0.05 }}
              >
                <div className={classes.titleBarLight}>
                  <div className={classes.dots}>
                    <div className={`${classes.dot} ${classes.dotRed}`}></div>
                    <div className={`${classes.dot} ${classes.dotYellow}`}></div>
                    <div className={`${classes.dot} ${classes.dotGreen}`}></div>
                  </div>
                  <div className={classes.tabLight}>
                    <FontAwesomeIcon icon={faCode} className={classes.tabIcon} /> Bio.md
                  </div>
                </div>
                <div className={classes.boxBody}>
                  <Row>
                    <Col xs={12} sm={12} md={12}>
                      <motion.div
                        className={`${classes.boxBodyTitle} mt-4 mb-4`}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{
                          duration: 0.25,
                          ease: "easeOut",
                          delay: 0.1,
                        }}
                      >
                        Davide Balice
                      </motion.div>

                      <motion.div
                        className={`${classes.boxBodyText} mt-4 mb-5}`}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{
                          duration: 0.25,
                          ease: "easeOut",
                          delay: 0.15,
                        }}
                      >
                        {lang === "en" && (
                          <>
                            <p>
                              I've been in the industry for + than 15 years, I
                              started with the php, mysql and javascript stack,
                              but have been exploring new technologies and
                              frameworks for the past few years.
                            </p>
                            <p>
                              In recent years, I have worked on several projects
                              that have allowed me to gain experience in
                              different areas of programming, to grow
                              professionally, to learn teamwork and the ability
                              to work under pressure and meet deadlines.
                            </p>
                          </>
                        )}
                        {lang === "it" && (
                          <>
                            <p>
                              Sono nel settore da più di 15 anni, ho iniziato
                              con lo stack php, mysql e javascript, ma negli
                              ultimi anni sono passato ai moderni framework
                              richiesti dal mercato.
                            </p>
                            <p>
                              Negli ultimi anni ho lavorato a diversi progetti
                              che mi hanno permesso di acquisire esperienza in
                              diversi ambiti della programmazione, per crescere
                              professionalmente, per imparare il lavoro di
                              squadra e la capacità di lavorare sotto pressione
                              e rispettare le scadenze.
                            </p>
                          </>
                        )}
                      </motion.div>
                    </Col>
                  </Row>

                  <motion.div
                    className={classes.boxBodyText}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 0.25,
                      ease: "easeOut",
                      delay: 0.2,
                    }}
                  >
                    {lang === "en" && (
                      <>
                        <p>
                          The websites created since the beginning of my career
                          have always been based on cms developed by me, I have
                          never used existing cms on the market, in particular I
                          have created cms with drag and drop graphical
                          interfaces, or with block graphic editors with many
                          options and possibility of graphic customization. This
                          has allowed me to have a greater level of
                          customization, to be able to better satisfy the needs
                          of customers, and to be able to manage the work
                          environment in complete autonomy.
                        </p>
                      </>
                    )}
                    {lang === "it" && (
                      <>
                        <p>
                          I siti web creati dall'inizio della mia carriera sono
                          sempre stati basati su cms sviluppati da me, non ho
                          mai usato cms esistenti sul mercato, in particolare ho
                          creato cms con interfacce grafiche drag and drop, o
                          con editor grafici a blocchi con molte opzioni e
                          possibilità di personalizzazione grafica. Questo mi ha
                          permesso di avere un maggior livello di
                          personalizzazione, poter soddisfare al meglio le
                          esigenze dei clienti ed essere in grado di gestire
                          l'ambiente di lavoro in completa autonomia.
                        </p>
                      </>
                    )}
                  </motion.div>
                </div>
              </motion.div>

              <motion.div
                className={classes.boxText + " mt-4"}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3, ease: "easeOut", delay: 0.05 }}
              >
                <div className={classes.titleBarLight}>
                  <div className={classes.dots}>
                    <div className={`${classes.dot} ${classes.dotRed}`}></div>
                    <div className={`${classes.dot} ${classes.dotYellow}`}></div>
                    <div className={`${classes.dot} ${classes.dotGreen}`}></div>
                  </div>
                  <div className={classes.tabLight}>
                    <FontAwesomeIcon icon={faAward} className={classes.tabIcon} /> Certifications.json
                  </div>
                </div>
                <div className={classes.boxBody}>
                  <motion.div
                    className={classes.boxBodyTitle}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 0.25,
                      ease: "easeOut",
                      delay: 0.1,
                    }}
                  >
                    {lang === "en" && <>Certifications and Courses</>}
                    {lang === "it" && <>Certificati e Coursi</>}
                  </motion.div>
                  <div className={classes.boxBodyLinea}></div>
                  <div className={classes.certificationsContainer}>
                    <div>
                      <div className={classes.certificationsImgContainer}>
                        <img src={lpi} alt="linux professional institute" />
                      </div>
                      <div className={classes.certificationsTextContainer}>
                        <b>Linux Professional Institute</b>
                        <br />
                        Web Development Essentials Exam 030-100
                      </div>
                    </div>
                    <div>
                      <div className={classes.certificationsImgContainer}>
                        <img src={lacerba} alt="lacerba" />
                      </div>
                      <div className={classes.certificationsTextContainer}>
                        <b>Lacerba</b>
                        <br />
                        Full stack developer
                      </div>
                    </div>
                    <div>
                      <div className={classes.certificationsImgContainer}>
                        <img src={ccna} alt="ccna" />
                      </div>
                      <div className={classes.certificationsTextContainer}>
                        <b>CCNA</b>
                        <br />
                        Cisco networking certification CCNA
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>

              <motion.div
                className={classes.boxText + " mt-4"}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3, ease: "easeOut", delay: 0.05 }}
              >
                <div className={classes.titleBarLight}>
                  <div className={classes.dots}>
                    <div className={`${classes.dot} ${classes.dotRed}`}></div>
                    <div className={`${classes.dot} ${classes.dotYellow}`}></div>
                    <div className={`${classes.dot} ${classes.dotGreen}`}></div>
                  </div>
                  <div className={classes.tabLight}>
                    <FontAwesomeIcon icon={faBriefcase} className={classes.tabIcon} /> Experience.log
                  </div>
                </div>
                <div className={classes.boxBody}>
                  <motion.div
                    className={classes.boxBodyTitle}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 0.25,
                      ease: "easeOut",
                      delay: 0.1,
                    }}
                  >
                    {lang === "en" && <>Working Experience</>}
                    {lang === "it" && <>Esperienza lavorativa</>}
                  </motion.div>
                  <div className={classes.boxBodyLinea}></div>
                  <div className="row">
                    <div className={`${classes.workingTableSx} col-auto`}>
                      <div className={classes.workingDate}>2005 - 2006</div>
                    </div>
                    <div className={`${classes.workingTableDx} col-auto`}>
                      <div className={classes.workingTitle}>Web master</div>

                      <div className={`${classes.workingImg} mt-3 bold`}>
                        Rhegion Travel
                      </div>
                      <div className={classes.workingDescription + " mt-4"}>
                        {lang === "en" && (
                          <>
                            First work experience, my task was to manage the
                            tourism portal, created in Asp, development,
                            management, new implementations, interfacing with
                            external systems.
                            <br />
                            Furthermore, this work experience has brought me
                            closer to the world of tourism, an experience that
                            will come in handy for me in the coming years.
                          </>
                        )}
                        {lang === "it" && (
                          <>
                            Prima esperienza lavorativa, il mio compito è stato
                            gestire il portale turistico, realizzato in Asp,
                            sviluppo, gestione, nuove implementazioni,
                            interfacciamento a sistemi esterni.
                            <br />
                            Inoltre questa esperienza lavorativa mi ha
                            avvicinato al mondo del turismo, esperienza che mi
                            tornerà utile nei prossimi anni.
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  <motion.div
                    className={classes.workingTableMt + " row"}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 0.25,
                      ease: "easeOut",
                      delay: 0.1,
                    }}
                  >
                    <div className={`${classes.workingTableSx} col-auto`}>
                      <div className={classes.workingDate}>2006 - 2012</div>
                    </div>
                    <div className={`${classes.workingTableDx} col-auto`}>
                      <div className={classes.workingTitle}>
                        Web developer - cofounder
                      </div>
                      <div className={classes.workingImg}>
                        <img src={aroundweb} alt="aroundweb" className="mt-3" />
                      </div>
                      <div className={classes.workingDescription + " mt-4"}>
                        {lang === "en" && (
                          <>
                            In 2006 I opened a web agency that distinguished for
                            its professionalism and creativity in the area.
                            <br />
                            Aroundweb has been active for 7 years, I actively
                            participated in the planning and development phases
                            of the projects, using different technologies to
                            ensure optimal functionality and high-level user
                            experience. I managed customer relations, listening
                            to their needs and translating them into
                            technological solutions.
                            <br />
                            I have worked for important clients such as Rotary,
                            the Regione Calabria, local TVs, press agencies,
                            various politicians including the President of
                            Regione Calabria.
                            <br />
                            Being able to manage a web agency has made me grow
                            as a professional, and has made me develop other
                            skills in addition to the technical ones, such as
                            customer relationship management.
                          </>
                        )}
                        {lang === "it" && (
                          <>
                            Nel 2006 ho aperto una web agency che si è
                            contradistinta per professionalità e creatività sul
                            territorio.
                            <br />
                            Aroundweb è stata attiva per 7 anni, ho partecipato
                            attivamente alle fasi di pianificazione e sviluppo
                            dei progetti, utilizzando diverse tecnologie per
                            garantire la funzionalità ottimale e l'esperienza
                            utente di alto livello. Ho gestito le relazioni con
                            i clienti, ascoltando le loro esigenze e
                            traducendole in soluzioni tecnologiche.
                            <br />
                            Ho lavorato per clienti importanti come Rotary,
                            Regione Calabria, Tv locali, Agenzie stampa, diversi
                            politici tra cui il Presidente della Regione
                            Calabria.
                            <br />
                            Poter gestire una web agency mi ha fatto crescere
                            come professionista, e mi ha fatto sviluppare altre
                            skill oltre a quelle tecniche, come la gestione dei
                            rapporti con i clienti.
                          </>
                        )}
                      </div>
                    </div>
                  </motion.div>

                  <motion.div
                    className={classes.workingTableMt + " row"}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 0.25,
                      ease: "easeOut",
                      delay: 0.15,
                    }}
                  >
                    <div className={`${classes.workingTableSx} col-auto`}>
                      <div className={classes.workingDate}>2012 - 2024</div>
                    </div>
                    <div className={`${classes.workingTableDx} col-auto`}>
                      <div className={classes.workingTitle}>
                        Full stack developer - cofounder
                      </div>
                      <div className={classes.workingImg}>
                        <img src={gadaweb} alt="gadaweb" className="mt-3" />
                      </div>
                      <a
                        href="https://www.gadaweb.com"
                        target="_blank"
                        title="gadaweb"
                        rel="noreferrer"
                      >
                        <div className={classes.workingUrl + " mt-4"}>
                          www.gadaweb.com
                        </div>
                      </a>
                      <div className={classes.workingDescription + " mt-4"}>
                        {lang === "en" && (
                          <>
                            Gadaweb was born from the need to bring our own
                            services on the national territory, immediately it
                            is focus on making platforms in formula
                            subscription, oriented to the world of tourism.
                            <br />
                            Sitiwebturismo.it was developed over the years,
                            service portal for travel agencies, tours operators
                            and accommodation facilities, Doyouall, drag and
                            drop platform for making websites, and SitiShop, a
                            responsive platform for website creation.
                            <br />
                            All services are interconnected with each other and
                            scalable, and can be tailored as needed of the
                            customers. Carrying out such large projects ed
                            challenges made me grow as a professional and
                            developer, made me develop skills of problem solving
                            and ability to meet deadlines.
                          </>
                        )}
                        {lang === "it" && (
                          <>
                            Gadaweb nasce dalla necessità di portare i nostri
                            servizi sul territorio nazionale, da subito si è
                            concentrati nel realizzare piattaforme in formula
                            abbonamento, orientati al mondo del turismo.
                            <br />
                            Nel anni è stato sviluppato Sitiwebturismo.it,
                            portale di servizi per Agenzie di viaggio, Tour
                            operator e Strutture ricettive, Doyouall,
                            piattaforma drag and drop per la realizzazione di
                            siti web, e SitiShop, piattaforma responsive per la
                            creazione di siti web.
                            <br />
                            Tutti i servizi sono interconnessi tra loro e
                            scalabili, e possono essere adattati alle esigenze
                            del clienti. Realizzare progetti cosi grandi ed
                            impegnativi mi ha fatto crescere come professionista
                            e sviluppatore, mi ha fatto sviluppare capacità di
                            problem solving e capacità di rispettare scadenze.
                          </>
                        )}
                      </div>
                    </div>
                  </motion.div>

                  <motion.div
                    className={classes.workingTableMt + " row"}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 0.25,
                      ease: "easeOut",
                      delay: 0.2,
                    }}
                  >
                    <div className={`${classes.workingTableSx} col-auto`}>
                      <div className={classes.workingDate}>2024 - NOW</div>
                    </div>
                    <div className={`${classes.workingTableDx} col-auto`}>
                      <div className={classes.workingTitle}>
                        Full stack developer - freelance
                      </div>
                      <div className={classes.workingImg}>
                        <img
                          src={logo}
                          alt="davidebalice.dev logo"
                          className="mt-3"
                          style={{ width: "100px" }}
                        />
                      </div>

                      <div className={classes.workingDescription + " mt-4"}>
                        {lang === "en" && (
                          <>
                            Freelance Developer Activities for various clients,
                            focusing on the design, development, and management
                            of customized software solutions.
                            <br />
                            Experience in creating and maintaining CRM systems,
                            optimizing business processes, and improving
                            operational efficiency.
                            <br />
                            Skills in web development, both backend and
                            frontend, API integration, and database management.
                          </>
                        )}
                        {lang === "it" && (
                          <>
                            Attività di sviluppatore freelance per diversi
                            clienti, con un focus sulla progettazione, sviluppo
                            e gestione di soluzioni software personalizzate.
                            <br />
                            Esperienza nella creazione e manutenzione di CRM,
                            ottimizzando processi aziendali e migliorando
                            l'efficienza operativa.
                            <br />
                            Competenze in sviluppo backend e frontend,
                            integrazione API e gestione di database.
                            <br />

                          </>
                        )}
                      </div>
                    </div>
                  </motion.div>







                  <motion.div
                    className={classes.workingTableMt + " row"}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{
                      duration: 0.25,
                      ease: "easeOut",
                      delay: 0.25,
                    }}
                  >
                    <div className={`${classes.workingTableSx} col-auto`}>
                      <div className={classes.workingDate}>2025 - NOW</div>
                    </div>
                    <div className={`${classes.workingTableDx} col-auto`}>
                      <div className={classes.workingTitle}>
                        Full stack developer
                      </div>
                      <div className={`${classes.workingImg} d-flex align-items-center gap-4 mt-3`}>
                        <img
                          src={dva}
                          alt="dva logo"
                          style={{ width: "100px", height: "auto" }}
                        />
                        <img
                          src={itgo}
                          alt="itgo logo"
                          style={{ width: "100px", height: "auto" }}
                        />
                      </div>

                      <div className={classes.workingDescription + " mt-4"}>
                        {lang === "en" && (
                          <>
                            Development of corporate websites and software solutions for the logistics, customs, CRM and warehouse management sectors at ItGo Srl, a software house of the DVA Express logistics group.
                          </>
                        )}
                        {lang === "it" && (
                          <>
                            Sviluppo siti web aziendali e soluzioni software per i settori logistica, doganale, CRM e gestione magazzino presso ItGo Srl, software house del gruppo logistico DVA Express.
                          </>
                        )}
                      </div>
                    </div>
                  </motion.div>


















                  <br />
                  <br />
                </div>
              </motion.div>
            </Col>
          </Row>
          <Spacer height="100" />
        </Container>
      </Container>
      <script src="vendor/jquery/jquery.min.js"></script>
      <script src="vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
      <script src="js/theme.js"></script>
    </>
  );
};

export default AboutMe;
